"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = exports.types = void 0;
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable default-param-last  cambio   */
// const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
const next13_components_modal_1 = __importDefault(require("@gerenciatd/next13.components.modal"));
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
exports.types = {
    INIT_ANCHOR_MODAL_LISTENER: 'MODAL/INIT_ANCHOR_MODAL_LISTENER',
    ADD_MODAL: 'MODAL/ADD_MODAL',
    SET_MODAL_HISTORY: 'MODAL/SET_MODAL_HISTORY',
};
exports.actions = {
    /* SSEO */
    initAnchorModalListener: () => ({
        type: exports.types.INIT_ANCHOR_MODAL_LISTENER,
    }),
    addModal: (data) => ({
        type: exports.types.ADD_MODAL,
        data,
    }),
    setModalHistory: (data) => ({
        type: exports.types.SET_MODAL_HISTORY,
        data,
    }),
};
const initialState = {
    Modal: null,
    modalHistory: [],
};
const ModalReducer = (state = initialState, action) => {
    switch (action.type) {
        case HYDRATE: {
            const { modals } = action.payload;
            return Object.assign(Object.assign({}, state), modals);
        }
        case exports.types.ADD_MODAL: {
            if (!state.Modal) {
                return Object.assign(Object.assign({}, state), { Modal: next13_components_modal_1.default });
            }
            return state;
        }
        case exports.types.SET_MODAL_HISTORY: {
            return Object.assign(Object.assign({}, state), { modalHistory: [...action.data] });
        }
        default: return Object.assign({}, state);
    }
};
exports.default = ModalReducer;
//# sourceMappingURL=index.js.map